<template>
	<app-panel title="Stock Summary" compact @click="stockSummaryOpen = true">
		<div class="flex items-center px-4 py-3">
			<div class="flex-2 flex">
				<div class="flex flex-col space-y-[2px]">
					<div v-for="(stat, index) in stats" :key="index" class="flex items-center">
						<p v-if="stat.value" class="text-gray-700 text-xs mr-2" data-testid="label">
							{{ stat.label }}:
						</p>
						<p v-if="stat.value" class="text-gray-700 text-xs" data-testid="stat">
							{{ stat.value }}
						</p>
					</div>
				</div>
			</div>
			<div class="flex-2 flex ml-auto justify-end text-right space-x-2">
				<app-icon :icon="['fas', 'fa-chevron-right']" class="text-xl text-mabey-950" />
			</div>
		</div>
	</app-panel>
	<slideover title="Stock Summary" :open="stockSummaryOpen" @close="stockSummaryOpen = false">
		<StockDetailTable v-if="journey" :items="journey.items" />
	</slideover>
</template>

<script lang="ts" setup>
	import { ref, computed } from 'vue'
	import type { Journey } from '@/data/schema/journey'
	import StockDetailTable from '@/components/datatables/driver-app/StockDetailTable.vue'

	const props = withDefaults(
		defineProps<{
			journey: Journey
		}>(),
		{
			journey: undefined
		}
	)

	const stats = computed(() => {
		return [
			{
				label: 'Weight',
				value: props.journey.weight ? Number(props.journey.weight).toFixed(2) : null
			},
			{
				label: 'Total Items',
				value: props.journey.items?.length ?? 0
			}
		]
	})

	const stockSummaryOpen = ref(false)
</script>
